import { ComponentPrice } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/components_pb";

import { currencySymbolMapping } from "../constants/index";
import { getCurrencyFromString } from "./get-currency-from-string";

export const getComponentPriceLabel = (
  componentPrice: ComponentPrice,
  unitLabel: string,
): string => {
  const currency = getCurrencyFromString(componentPrice.currency);
  const symbol = currencySymbolMapping[currency];
  const price = componentPrice.price / 100;
  if (componentPrice.name) {
    return `${componentPrice.name} - ${symbol}${price}/${unitLabel}`;
  } else {
    return `${componentPrice.sku} - ${symbol}${price}/${unitLabel}`;
  }
};
